import { render, staticRenderFns } from "./stdwipcost.vue?vue&type=template&id=36a2ac64&scoped=true&"
import script from "./stdwipcost.vue?vue&type=script&lang=js&"
export * from "./stdwipcost.vue?vue&type=script&lang=js&"
import style0 from "./stdwipcost.vue?vue&type=style&index=0&id=36a2ac64&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2ac64",
  null
  
)

export default component.exports